// extracted by mini-css-extract-plugin
export default {"btnContainer":"NavigationMenu_btnContainer__h+ASn","container":"NavigationMenu_container__P1qFv"};